<template>
  <div v-if="isMenu">
    <v-menu v-model="menu" absolute :close-on-content-click="false" offset-y>
      <template v-slot:activator="{ on }">
        <div class="d-flex flex-row align-center btn-container full-width ">
          <v-text-field
            dense
            hide-details=""
            :label="label"
            outlined
            readonly
            :value="currentItem.text"
            v-on="on"
          ></v-text-field>
        </div>
      </template>
      <v-card flat width="450px">
        <v-btn
          v-for="(item, index) in items"
          :key="index"
          class="ma-2"
          depressed
          outlined
          @click="handler(item)"
        >
          {{ item.text }}
        </v-btn>
        <div v-if="isCustom" class="pa-2">
          <v-row class="ma-0">
            <v-col class="px-0" cols="12">
              <FieldDate
                v-model="dayStart"
                :label="$t('field-select-date.start-date')"
                :max="ymdDayEnd"
                @input="resetData"
              ></FieldDate>
            </v-col>
            <v-col class="px-0" cols="12">
              <FieldDate
                v-model="dayEnd"
                :label="$t('field-select-date.end-date')"
                :min="ymdDayStart"
                @input="resetData"
              ></FieldDate>
            </v-col>
          </v-row>
        </div>
      </v-card>
    </v-menu>
  </div>
  <div v-else class="d-flex align-center full-height flex-column">
    <v-menu v-model="menu" absolute offset-y>
      <template v-slot:activator="{ on }">
        <div class="d-flex flex-row align-center btn-container full-width ">
          <span class="label-name">
            {{ label }}
          </span>
          <base-button text v-on="on">
            {{ currentItem.text }}
          </base-button>
        </div>
      </template>
      <v-list>
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          @click="handler(item)"
        >
          <v-list-item-title>{{ item.text }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <div v-if="isCustom">
      <v-row class="ma-0">
        <v-col class="px-0" cols="12">
          <FieldDate
            v-model="dayStart"
            :label="$t('field-select-date.start-date')"
            :max="ymdDayEnd"
            @input="resetData"
          ></FieldDate>
        </v-col>
        <v-col class="px-0" cols="12">
          <FieldDate
            v-model="dayEnd"
            :label="$t('field-select-date.end-date')"
            :min="ymdDayStart"
            @input="resetData"
          ></FieldDate>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import FieldDate from './field-date.vue'
const moment = require('moment')
export default {
  // eslint-disable-next-line vue/no-unused-components
  components: { FieldDate },
  props: {
    isMenu: Boolean,
    timeStart: { type: String },
    timeEnd: { type: String },
    label: String,
    initSelect: {
      type: String,
      validator: function(value) {
        // The value must match one of these strings
        return ['all', 'latest', '7days', '30days'].indexOf(value) !== -1
      },
    },
  },
  data: (vm) => ({
    dayStart: '',
    dayEnd: '',
    isCustom: false,
    menu: false,
    items: [
      { text: vm.$t('field-select-date.items.all'), handler: () => vm.all() },
      {
        text: vm.$t('field-select-date.items.3days'),
        handler: () => vm.setDay(2),
      },
      {
        text: vm.$t('field-select-date.items.7days'),
        handler: () => vm.setDay(7),
      },
      {
        text: vm.$t('field-select-date.items.30days'),
        handler: () => vm.setDay(30),
      },
      {
        text: vm.$t('field-select-date.items.custom'),
        handler: () => vm.showCustom(),
      },
    ],
    currentItem: null,
    ymdDayStart: null,
    ymdDayEnd: null,
  }),
  watch: {
    initSelect: {
      handler(value) {
        if (!value || value == 'all') {
          this.currentItem = this.items[0]
        }
        if (value == 'latest') {
          this.currentItem = this.items[1]
          this.setDay(1, false)
        }
        if (value == '7days') {
          this.currentItem = this.items[2]
          this.setDay(7, false)
        }
        if (value == '30days') {
          this.currentItem = this.items[3]
          this.setDay(30, false)
        }
      },
      immediate: true,
    },
    dayStart: {
      handler(value) {
        this.ymdDayStart = value
          ? moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD')
          : null
      },
      immediate: true,
    },
    dayEnd: {
      handler(value) {
        this.ymdDayEnd = value
          ? moment(value, 'DD/MM/YYYY').format('YYYY-MM-DD')
          : null
      },
      immediate: true,
    },
  },
  computed: {
    diffDay() {
      let date1 = new Date(this.dayStart)
      let date2 = new Date(this.dayEnd)
      let diffTime = Math.abs(date2 - date1)
      let diffDay = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
      return diffDay
    },
  },
  methods: {
    parseDate(value) {
      return moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    all() {
      this.dayStart = null
      this.dayEnd = null
      this.resetData()
    },
    handler(item) {
      if (item) {
        this.isCustom = false
        this.currentItem = item
        item.handler()
      }
    },
    showCustom() {
      this.isCustom = true
      this.setDay(30, false)
    },
    resetData() {
      this.$emit('update:timeStart', this.dayStart)
      this.$emit('update:timeEnd', this.dayEnd)
      this.$emit('change', {
        timeStart: this.dayStart,
        timeEnd: this.dayEnd,
      })
    },
    setDay(day, reset = true) {
      let d = new Date()
      this.dayEnd = this.parseDate(d.toISOString().substr(0, 10))
      this.dayStart = this.parseDate(
        new Date(d.setDate(d.getDate() - day)).toISOString().substr(0, 10)
      )
      if (reset) this.resetData()
    },
  },
}
</script>

<style lang="scss">
.btn-container {
  width: 100%;
  justify-content: space-between;
  span {
    // font-size: 0.8rem;
    &.label {
      font-weight: 500;
      font-size: 14px;
    }
  }
}
</style>
